var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('h4',{staticClass:"step-title"},[_vm._v(" Are you married? ")]),_c('div',{staticClass:"step-content d-flex flex-column flex-md-row"},[_c('yes-no-button-list',{attrs:{"onclick":_vm.complete}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }